import MainLayout from '@layouts/Main'
import PassThrough from '@layouts/PassThrough'
import { hasRole } from './authorization/conditions'

export default [
  {
    path: '',
    component: MainLayout,
    children: [
      {
        path: '',
        redirect: '/login',
      },
    ],
  },

  {
    path: '/dashboard',
    component: () => import(/* webpackChunkName: "admin" */ '../views/layouts/Admin'),
    auth: hasRole('>=USER'),
    children: [
      {
        path: 'article',
        component: PassThrough,
        children: [
          {
            path: '',
            name: 'Articles',
            component: () => import(/* webpackChunkName: "admin" */ '../views/pages/Articles'),
          },
          {
            path: 'add',
            name: 'ArticlesAdd',
            component: () => import(/* webpackChunkName: "admin" */ '../views/pages/ArticlesAdd'),
          },
          {
            path: ':id',
            name: 'Article',
            component: () => import(/* webpackChunkName: "admin" */ '../views/pages/Article'),
          },
        ],
      },
      {
        path: 'article-topics',
        component: PassThrough,
        children: [
          {
            path: '',
            name: 'ArticleTopics',
            component: () => import(/* webpackChunkName: "admin" */ '../views/pages/ArticleTopics'),
          },
        ],
      },
      {
        path: 'blueprint',
        component: PassThrough,
        children: [
          {
            path: '',
            name: 'Blueprints',
            component: () => import(/* webpackChunkName: "admin" */ '../views/pages/Blueprints'),
          },
        ],
      },
      {
        path: 'laptopFlagged',
        component: PassThrough,
        children: [
          {
            path: '',
            name: 'LaptopsFlagged',
            component: () => import(/* webpackChunkName: "admin" */ '../views/pages/LaptopsFlagged'),
          },
          {
            path: ':id',
            name: 'LaptopFlagged',
            component: () => import(/* webpackChunkName: "admin" */ '../views/pages/LaptopFlagged'),
          },
        ],
      },
      {
        path: 'laptop',
        component: PassThrough,
        children: [
          {
            path: '',
            name: 'Laptops',
            component: () => import(/* webpackChunkName: "admin" */ '../views/pages/Laptops'),
          },
          {
            path: ':id',
            name: 'Laptop',
            component: () => import(/* webpackChunkName: "admin" */ '../views/pages/Laptop'),
          },
        ],
      },
      {
        path: 'featureFlag',
        component: PassThrough,
        children: [
          {
            path: '',
            name: 'FeatureFlags',
            component: () => import(/* webpackChunkName: "admin" */ '../views/pages/FeatureFlags'),
          },
        ],
      },
      {
        path: 'prompt',
        component: PassThrough,
        children: [
          {
            path: '',
            name: 'Prompts',
            component: () => import(/* webpackChunkName: "admin" */ '../views/pages/Prompts'),
          },
          {
            path: 'add',
            name: 'PromptsAdd',
            component: () => import(/* webpackChunkName: "admin" */ '../views/pages/PromptsAdd'),
          },
          {
            path: ':id',
            name: 'Prompt',
            component: () => import(/* webpackChunkName: "admin" */ '../views/pages/Prompt'),
          },
        ],
      },
      {
        path: 'sectionTemplate',
        component: PassThrough,
        children: [
          {
            path: '',
            name: 'SectionTemplates',
            component: () =>
              import(/* webpackChunkName: "admin" */ '../views/pages/SectionTemplates'),
          },
          {
            path: ':id',
            name: 'SectionTemplate',
            component: () =>
              import(/* webpackChunkName: "admin" */ '../views/pages/SectionTemplate'),
          },
        ],
      },
      {
        path: 'user',
        component: PassThrough,
        children: [
          {
            path: '',
            name: 'Users',
            component: () => import(/* webpackChunkName: "admin" */ '../views/pages/Users'),
          },
          {
            path: 'add',
            name: 'UsersAdd',
            component: () => import(/* webpackChunkName: "admin" */ '../views/pages/UsersAdd'),
          },
          {
            path: ':id',
            name: 'User',
            component: () => import(/* webpackChunkName: "admin" */ '../views/pages/User'),
          },
        ],
      },
      {
        path: 'mail',
        component: PassThrough,
        children: [
          {
            path: '',
            name: 'Mails',
            component: () => import(/* webpackChunkName: "admin" */ '../views/pages/Mails'),
          },
        ],
      },
      {
        path: 'site',
        component: PassThrough,
        children: [
          {
            path: '',
            name: 'Sites',
            component: () => import(/* webpackChunkName: "admin" */ '../views/pages/Sites'),
          },
          {
            path: 'add',
            name: 'SitesAdd',
            component: () => import(/* webpackChunkName: "admin" */ '../views/pages/SitesAdd'),
          },
          {
            path: ':id',
            name: 'Site',
            component: () => import(/* webpackChunkName: "admin" */ '../views/pages/Site'),
          },
        ],
      },
      {
        path: 'page-batch',
        component: PassThrough,
        children: [
          {
            path: '',
            name: 'PageBatches',
            component: () => import(/* webpackChunkName: "admin" */ '../views/pages/PageBatches'),
          },
          {
            path: 'add',
            name: 'PageBatchesAdd',
            component: () => import(/* webpackChunkName: "admin" */ '../views/pages/PageBatchesAdd'),
          },
          {
            path: ':id',
            name: 'PageBatch',
            component: () => import(/* webpackChunkName: "admin" */ '../views/pages/PageBatch'),
          },
        ],
      },
      {
        path: 'article-table',
        component: PassThrough,
        children: [
          {
            path: '',
            name: 'ArticleTable',
            component: () => import(/* webpackChunkName: "admin" */ '../views/pages/ArticleTable'),
          },
          {
            path: 'add',
            name: 'ArticleTableAdd',
            component: () =>
              import(/* webpackChunkName: "admin" */ '../views/pages/ArticleTableAdd'),
          },
        ],
      },
      {
        path: 'article-import',
        name: 'ArticleImport',
        component: () => import(/* webpackChunkName: "admin" */ '../views/pages/ArticleImport'),
      },
      {
        path: 'review-import',
        name: 'ReviewImport',
        component: () => import(/* webpackChunkName: "admin" */ '../views/pages/ReviewImport'),
      },
      {
        path: 'image',
        component: PassThrough,
        children: [
          {
            path: '',
            name: 'Images',
            component: () => import(/* webpackChunkName: "admin" */ '../views/pages/Images'),
          },
          {
            path: 'add',
            name: 'ImagesAdd',
            component: () => import(/* webpackChunkName: "admin" */ '../views/pages/ImagesAdd'),
          },
          {
            path: ':id',
            name: 'Image',
            component: () => import(/* webpackChunkName: "admin" */ '../views/pages/Image'),
          },
        ],
      },
    ],
  },

  {
    path: '',
    component: () => import(/* webpackChunkName: "auth" */ '../views/layouts/Auth'),
    children: [
      {
        path: '/login',
        name: 'Login',
        component: () => import(/* webpackChunkName: "auth" */ '../views/pages/Login'),
      },
      {
        path: '/login/forgot',
        name: 'LoginForgot',
        component: () => import(/* webpackChunkName: "auth" */ '../views/pages/LoginForgot'),
      },
      {
        path: '/login/reset',
        name: 'LoginReset',
        component: () => import(/* webpackChunkName: "auth" */ '../views/pages/LoginReset'),
      },
      // {
      //   path: '/signup',
      //   name: 'Signup',
      //   component: () => import(/* webpackChunkName: "auth" */ '../views/pages/Signup'),
      // },
      {
        path: '/signup/success',
        name: 'SignupSuccess',
        component: () => import(/* webpackChunkName: "auth" */ '../views/pages/SignupSuccess'),
      },
      {
        path: '/signup/verify',
        name: 'SignupVerify',
        component: () => import(/* webpackChunkName: "auth" */ '../views/pages/SignupVerify'),
      },
      {
        path: '/logout',
        name: 'Logout',
        component: () => import(/* webpackChunkName: "auth" */ '../views/pages/Logout'),
      },
    ],
  },

  {
    path: '/denied',
    name: 'Err401',
    component: () => import(/* webpackChunkName: "misc" */ '../views/pages/401/index.vue'),
  },
  {
    path: '*',
    name: 'Err404',
    component: () => import(/* webpackChunkName: "misc" */ '../views/pages/404/index.vue'),
  },
]
